import { render, staticRenderFns } from "./ColorsRadio.vue?vue&type=template&id=13f693f6&scoped=true"
import script from "./ColorsRadio.vue?vue&type=script&lang=js"
export * from "./ColorsRadio.vue?vue&type=script&lang=js"
import style0 from "./ColorsRadio.vue?vue&type=style&index=0&id=13f693f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f693f6",
  null
  
)

export default component.exports